export const theme = {
    colors: {
        textMain: "#000000FF",
        textSecondary: "rgba(0, 0, 0, 0.6)",
        textLight: "rgb(255,252,252)",
        textAdditional: "#636363",

        backgroundColor: "#f5f5f5",
        backgroundColorLight: "#ffffff",

        accentLight: "rgba(22,119,255,0.5)",
        accent: "rgb(22, 119, 255)",

        borderMain: "rgba(0, 0, 0, 0.6)",

        boxShadowMain: "#80808045",
    },
    transition: {
        all: "all .4s ease-in-out"
    },
    media: {
        desktop: "screen and (min-width: 1440px)",
        large: "screen and (max-width: 992px)",
        tablet: "screen and (max-width: 768px)",
        mobile: "screen and (max-width: 576px)",
        small: "screen and (max-width: 378px)",
        tabletTs: 768,
        mobileTs: 576,
    },
    height: {
        header: "65px"
    },
    width:{
        navBar: {
            max: "200px",
            min: "80px"
        }
    },
    borderRadius: {
        main: "8px"
    }
}